import { getColor } from 'common/constants/_colors';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import styled from 'styled-components';

const CircleBullet = styled(Flex)`
  width: 2rem;
  height: 2rem;
  border: 1px solid ${getColor('catskillWhite')};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  position: relative;
  ${({ b }) => b && `bottom: ${b}`};
`;

const StyledContainer = styled(Flex)`
  & > *:not(:last-child) {
    margin-bottom: 1.3rem;
  }
`;

const NumberedCircleListItem = props => {
  return (
    <CircleBullet {...props}>
      <Text size='medium'>{props.number}</Text>
    </CircleBullet>
  );
};

export const BulletStep = ({ number, description, content }) => {
  return (
    <Flex mb='medium' items={content ? 'flex-start' : 'center'}>
      {number && (
        <NumberedCircleListItem
          number={number}
          {...(content ? { b: '0.4rem' } : {})}
        />
      )}
      <StyledContainer pl='small' direction='column'>
        {description}
        {content}
      </StyledContainer>
    </Flex>
  );
};
